import {
  SET_BRANCHES,
  SET_CURRENT_BRANCH,
  SET_CURRENT_MOVE,
  FORWARD_CURRENT_BRANCH,
  ADD_BRANCH,
  DELETE_BRANCH,
  SET_PRIMARY_BRANCH
} from './actions'

const mutations = {
  [SET_BRANCHES]: (state, branches) => {
    state.branches = branches
    state.currentBranch = null
    state.currentMove = null
    state.primaryBranch = null
  },
  [SET_PRIMARY_BRANCH]: (state, branch) => {
    state.primaryBranch = branch
  },
  [SET_CURRENT_BRANCH]: (state, branch) => {
    state.currentBranch = branch
  },
  [SET_CURRENT_MOVE]: (state, move) => {
    state.currentMove = move
  },
  [FORWARD_CURRENT_BRANCH]: (state, revision) => {
    if ((state.currentBranch.histories.length + 1) === revision.move) {
      state.currentBranch.histories.unshift(revision)
    } else if (revision.move === 1) {
      state.currentBranch.histories = [revision]
    } else {
      let histories = state.currentBranch.histories
      // if histories is 5 and move is 3, then we want moves 2 and 1
      // so we want to get rid of 0 , 1, 2, and leave 3 and 4, so our begining is 3
      // length - move - 1 is the begining, then do a unshift
      // len 5 move 3 = 3 cause we want 2 1
      // len 5 move 5 = 1 cause we want 4 3 2 1  but not 5
      // len 5 move 1 = 5 cause we want []
      histories = histories.slice(histories.length - revision.move + 1)
      histories.unshift(revision)
      state.currentBranch.histories = histories
    }
    state.currentBranch = {
      ...state.currentBranch,
      audience: revision.audience
    }
    state.currentMove = revision
    const currentBranch = state.branches.find(b => b.id === state.currentBranch.id)
    currentBranch.audience = revision.audience
  },
  [SET_CURRENT_MOVE]: (state, revision) => {
    state.currentMove = revision
  },
  [ADD_BRANCH]: (state, branch) => {
    state.branches.push(branch)
    state.branches = [].concat(state.branches)
  },
  [DELETE_BRANCH]: (state, branchId) => {
    state.branches = state.branches.filter(b => b.id !== branchId)
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/app/appLogic/revisionHistory/store/mutations.js